module.exports = __webpack_public_path__ + "img/HU10197879.efd3c4ff.svg";